<style lang="sass">
    @import ../../common/styles/mixins
    @import ../../common/styles/settings

    .sticky-typeform
        position: fixed
        top: 50%
        right: 0
        background: #000099
        color: #ffffff
        padding: 1.25rem
        border-radius: 1rem 1rem 0 0
        z-index: 3
        font-size: 1.125rem
        box-shadow: 0 0 1.5rem 0.1rem rgba(0, 0, 0, 0.2)
        transform: translate(100%, 0%) rotate(-90deg)
        cursor: pointer
        max-height: 1rem

        +media("<=600px")
            bottom: 0
            top: auto
            right: 25%
            font-size: 0.875rem
            transform: translate(50%, 120%) rotate(0deg)
            padding: 0.75rem

        &.active
            transition: transform 800ms $authentic-motion-out
            transform: translate(34%, 0%) rotate(-90deg)
            +media("<=600px")
                transform: translate(50%, 0%) rotate(0deg)

</style>


<script>

    import $ from "jquery";
    import {Bus as VuedalsBus} from "vuedals"
    import TypeFormPopin from "./TypeFormPopin.vue"

    export default {

        beforeMount() {
            setTimeout(() => {
                $('.sticky-typeform').addClass('active');
            }, 1500);
        },

        methods: {

            open: function() {
                VuedalsBus.$emit('new', {
                    name: 'typeform',
                    component: TypeFormPopin
                });
                return false;
            }
        }
    }

</script>